import { Container } from './primitives';
import { LogoMark } from './logo-mark';

interface FooterColProps {
  title: string;
  links: string[];
}

function FooterCol({ title, links }: FooterColProps) {
  return (
    <div>
      <div className="eyebrow" style={{ color: 'rgba(250,250,247,0.5)', marginBottom: 16 }}>{title}</div>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
        {links.map((l) => (
          <li key={l}>
            <a href="#" style={{ color: 'rgba(250,250,247,0.85)', textDecoration: 'none', fontSize: 14 }} className="under">
              {l}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Footer() {
  return (
    <footer style={{ background: 'var(--ink)', color: 'var(--paper)', marginTop: 88 }}>
      <Container>
        <div style={{ padding: '64px 0 32px', display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 40 }} className="m-cols-2 m-gap">
          <div>
            <div style={{ marginBottom: 22 }}>
              <LogoMark mono />
            </div>
            <p style={{ maxWidth: 380, color: 'rgba(250,250,247,0.72)', fontSize: 14, lineHeight: 1.6 }}>
              La Biblioteca Digital del Fondo de Cultura Económica reúne el catálogo del FCE para préstamo gratuito. Sin publicidad, sin costo, para todo México y América Latina.
            </p>
            <div style={{ marginTop: 24, display: 'flex', gap: 24 }}>
              <div className="eyebrow" style={{ color: 'rgba(250,250,247,0.5)' }}>Un programa de</div>
            </div>
            <div style={{ marginTop: 10, fontFamily: 'var(--serif)', fontSize: 15, color: 'var(--paper)' }}>
              Fondo de Cultura Económica · México
            </div>
          </div>
          <FooterCol title="Catálogo" links={['Novedades', 'Narrativa', 'Poesía', 'Ensayo', 'Historia']} />
          <FooterCol title="Mi cuenta" links={['Mi estantería', 'Favoritos', 'Préstamos activos']} />
          <FooterCol title="Instituto" links={['Sobre el FCE', 'Términos', 'Privacidad', 'Accesibilidad', 'Contacto']} />
        </div>
        <hr style={{ border: 'none', borderTop: '1px solid rgba(250,250,247,0.14)' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '22px 0', flexWrap: 'wrap', gap: 16 }}>
          <div style={{ fontSize: 12, color: 'rgba(250,250,247,0.6)' }}>
            Av. Picacho Ajusco 227, Col. Bosques del Pedregal · Ciudad de México · contacto@fce.com.mx
          </div>
          <div style={{ display: 'flex', gap: 18 }}>
            {['Twitter', 'Instagram', 'YouTube'].map((s) => (
              <a key={s} href="#" style={{ color: 'rgba(250,250,247,0.72)', textDecoration: 'none', fontSize: 13 }}>
                {s}
              </a>
            ))}
          </div>
        </div>
      </Container>
    </footer>
  );
}
